package one.healthium.ui.compose.components

import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.material3.CenterAlignedTopAppBar
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.LocalTextStyle
import androidx.compose.material3.TopAppBarColors
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.material3.TopAppBarScrollBehavior
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.Stable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import one.healthium.ui.compose.platform.PlatformColorsEffect
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.black

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun AppTopBar(
    modifier: Modifier = Modifier,
    title: @Composable () -> Unit = {},
    navigationIcon: @Composable () -> Unit = {},
    colors: TopAppBarColors? = null,
    windowInsets: WindowInsets = TopAppBarDefaults.windowInsets,
    expandedHeight: Dp = 56.dp,
    actions: @Composable RowScope.() -> Unit = {},
    scrollBehavior: TopAppBarScrollBehavior? = null,
) {
    val style = AppTheme.appTopBarStyle

    if (style.lightStatusBar != null) {
        PlatformColorsEffect(lightStatusBar = style.lightStatusBar)
    }

    CenterAlignedTopAppBar(
        modifier = modifier,
        title = {
            CompositionLocalProvider(LocalTextStyle provides (style.style ?: AppTheme.textStyles.secondary_17_400)) {
                title()
            }
        },
        navigationIcon = navigationIcon,
        expandedHeight = expandedHeight,
        colors = colors ?: style.colors ?: AppTopBarDefaults.colors(),
        windowInsets = windowInsets,
        actions = actions,
        scrollBehavior = scrollBehavior,
    )
}

@OptIn(ExperimentalMaterial3Api::class)
object AppTopBarDefaults {
    @Composable
    fun colors(
        containerColor: Color? = null,
        titleContentColor: Color? = null,
        navigationIconContentColor: Color? = null,
    ): TopAppBarColors {
        return TopAppBarDefaults.centerAlignedTopAppBarColors(
            containerColor = containerColor ?: AppTheme.colors.primary,
            scrolledContainerColor = containerColor ?: AppTheme.colors.primary,
            titleContentColor = titleContentColor ?: AppTheme.colors.onPrimary,
            navigationIconContentColor = navigationIconContentColor ?: AppTheme.colors.onPrimary,
        )
    }

    val transparent: TopAppBarColors
        @Composable get() = TopAppBarDefaults.centerAlignedTopAppBarColors(
            containerColor = Color.Transparent,
            titleContentColor = black,
            navigationIconContentColor = black,
        )
}

@Stable
data class AppTopBarStyle(
    val colors: TopAppBarColors? = null,
    val style: TextStyle? = null,
    val lightStatusBar: Boolean? = null,
)
